import { HTMLAttributes } from 'react';

import { Container, ContainerProps } from './styles';

export type TextProps = HTMLAttributes<HTMLElement> & ContainerProps;

export default function Text({
  className,
  variant = 'body2',
  display = 'inline-flex',
  ...rest
}: TextProps) {
  return (
    <Container
      className={className}
      display={display}
      variant={variant}
      {...rest}
    />
  );
}
